import styled, { keyframes } from "styled-components";

// Modal animations
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { 
    opacity: 0; 
    transform: translate(-50%, -60%) scale(0.9) !important;  
  }
  to { 
    opacity: 1; 
    transform: translate(-50%, -50%) scale(1) !important; 
  }
`;

// Modal Overlay
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: ${fadeIn} 0.3s ease-out;
`;

// Modal Container
export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  border: 2px solid #ff6b35;
  border-radius: 20px;
  padding: 2.5rem;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  animation: ${slideIn} 0.4s ease-out;
  box-shadow: 0 25px 50px rgba(255, 107, 53, 0.3);
  /* position: relative; */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="%23ff6b35" opacity="0.1"/><circle cx="75" cy="75" r="1.5" fill="%23ff6b35" opacity="0.1"/><circle cx="50" cy="10" r="0.8" fill="%23ff6b35" opacity="0.1"/><circle cx="10" cy="60" r="1.2" fill="%23ff6b35" opacity="0.1"/><circle cx="90" cy="30" r="0.9" fill="%23ff6b35" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    border-radius: 20px;
    z-index: 1;
  }
`;

// Close Button
export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  z-index: 2;

  &:hover {
    background: rgba(255, 107, 53, 0.2);
    color: #ff6b35;
    transform: rotate(90deg);
  }
`;

// Modal Content
export const ModalContent = styled.div`
  position: relative;
  z-index: 2;
`;

// Modal Header
export const ModalHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  h3 {
    color: #ff6b35;
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }

  p {
    color: #cccccc;
    font-size: 1rem;
    line-height: 1.5;
  }
`;

// Email Display
export const EmailDisplay = styled.div`
  background: rgba(255, 107, 53, 0.1);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 2rem;
  text-align: center;

  span {
    color: #ff6b35;
    font-weight: bold;
    font-size: 1.1rem;
  }
`;

// Preferences Section
export const PreferencesSection = styled.div`
  margin-bottom: 2rem;
`;

export const PreferencesTitle = styled.h4`
  color: #ffffff;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

// Checkbox Items
export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CheckboxItem = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #444;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  overflow: hidden;
  &:hover {
    background: rgba(255, 107, 53, 0.1);
    border-color: #ff6b35;
    transform: translateX(5px);
  }

  &.checked {
    background: rgba(255, 107, 53, 0.15);
    border-color: #ff6b35;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: #ff6b35;
      border-radius: 0 12px 12px 0;
    }
  }
`;

export const CustomCheckbox = styled.input`
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #666;
  border-radius: 4px;
  background: transparent;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:checked {
    background: #ff6b35;
    border-color: #ff6b35;

    &::after {
      content: "✓";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #ffffff;
      font-size: 0.8rem;
      font-weight: bold;
    }
  }

  &:hover {
    border-color: #ff6b35;
  }
`;

export const CheckboxContent = styled.div`
  flex: 1;

  h5 {
    color: #ffffff;
    font-size: 1rem;
    margin-bottom: 0.3rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  p {
    color: #cccccc;
    font-size: 0.9rem;
    line-height: 1.4;
    margin: 0;
  }
`;

export const CheckboxIcon = styled.span`
  color: #ff6b35;
  font-size: 1.2rem;
`;

// Modal Actions
export const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const ModalButton = styled.button`
  padding: 1rem 2rem;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 140px;
  justify-content: center;

  &.primary {
    background: linear-gradient(135deg, #ff6b35, #ff8c42);
    color: #ffffff;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #e55a2b, #ff6b35);
      transform: translateY(-2px);
      box-shadow: 0 10px 25px rgba(255, 107, 53, 0.4);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  }

  &.secondary {
    background: transparent;
    color: #ffffff;
    border: 2px solid #666;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: #ffffff;
      transform: translateY(-2px);
    }
  }
`;

// Error Message
export const ErrorMessage = styled.div`
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  color: #e74c3c;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

// Success Message
export const SuccessMessage = styled.div`
  background: rgba(39, 174, 96, 0.1);
  border: 1px solid rgba(39, 174, 96, 0.3);
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  color: #27ae60;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

// Footer Note
export const FooterNote = styled.div`
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #444;

  p {
    color: #999;
    font-size: 0.8rem;
    line-height: 1.4;

    strong {
      color: #ff6b35;
    }
  }
`;

// Select All Button
export const SelectAllButton = styled.button`
  background: transparent;
  border: 1px solid #ff6b35;
  color: #ff6b35;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 1rem;

  &:hover {
    background: rgba(255, 107, 53, 0.1);
  }

  &.selected {
    background: #ff6b35;
    color: #ffffff;
  }
`;
